import { Activity, PackageType } from "$types";
import { AppThunk } from "$store";

export const load = (): AppThunk => (dispatch) => {
  dispatch({
    type: "LOAD_API",
  });
};

export const loadOut = (): AppThunk => (dispatch) => {
  dispatch({
    type: "LOADOUT_API",
  });
};

export const pending = (): AppThunk => (dispatch) => {
  dispatch({
    type: "PENDING_API",
  });
};

export const pendingOut = (): AppThunk => (dispatch) => {
  dispatch({
    type: "PENDING_END_API",
  });
};

export const resetCategory = (): AppThunk => (dispatch) => {
  dispatch({
    type: "RESET_CATEGORIES",
  });
};

export const setCategory =
  (categories: any): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_CATEGORIES",
      payload: { categories },
    });
  };

export const setCompany =
  (companies: any, companiesLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_COMPANIES",
      payload: { companies, companiesLoader: companiesLoader || false },
    });
  };

export const setCompaniesFromUser =
  (companiesFromUser: any, companiesFromUserLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_COMPANIES_FROM_USER",
      payload: {
        companiesFromUser,
        companiesLoader: companiesFromUserLoader || false,
      },
    });
  };

export const refreshCategory = (): AppThunk => (dispatch) => {
  dispatch({
    type: "REFRESH_CATEGORIES",
  });
};

export const setUsers =
  (users: any, usersLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_USERS",
      payload: { users, usersLoader: usersLoader || false },
    });
  };

export const setProjects =
  (projects: any, projectLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_PROJECTS",
      payload: { projects, projectLoader: projectLoader || false },
    });
  };

export const setDockyards =
  (dockyards: any, dockyardsLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_DOCKYARDS",
      payload: { dockyards, dockyardsLoader: dockyardsLoader || false },
    });
  };

export const setEdbs =
  (edbs: any, edbsLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_EDBS",
      payload: { edbs, edbsLoader: edbsLoader || false },
    });
  };

export const setOps =
  (ops: any, opsLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_OPS",
      payload: { ops, opsLoader: opsLoader || false },
    });
  };

export const setStocks =
  (stocks: any): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_STOCKS",
      payload: { stocks },
    });
  };

export const setEntrepots =
  (entrepots: any, entrepotsLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_ENTREPOTS",
      payload: { entrepots, entreprotsLoader: entrepotsLoader || false },
    });
  };

export const setProducts =
  (products: any, productsLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_PRODUCTS",
      payload: { products, productsLoader: productsLoader || false },
    });
  };

export const setWMSConfigs =
  (wmsConfigs: any, wmsConfigLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_WMSCONFIGS",
      payload: { wmsConfigs, wmsConfigLoader: wmsConfigLoader || false },
    });
  };
export const setPackageTypes =
  (packageTypes: PackageType[], packageTypesLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_PACKAGE_TYPES",
      payload: {
        packageTypes,
        packageTypesLoader: packageTypesLoader || false,
      },
    });
  };

export const setActivities =
  (activities: Activity[], activitiesLoader?: boolean): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "PUSH_ACTIVITIES",
      payload: {
        activities,
        activitiesLoader: activitiesLoader || false,
      },
    });
  };
